var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_368_7111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.48046 13.0219C1.78673 13.0219 0.413696 14.4016 0.413696 16.1036C0.413696 17.8056 1.78673 19.1853 3.48046 19.1853H54.63C56.3237 19.1853 57.6968 17.8056 57.6968 16.1036C57.6968 14.4016 56.3237 13.0219 54.63 13.0219H3.48046Z",
    fill: "#FF7246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6177 0.217041C11.8567 0.217041 9.59701 2.48778 9.59701 5.26217V5.38169C9.19774 5.27925 8.77298 5.21095 8.33972 5.21095C5.57878 5.21095 3.31906 7.48169 3.31906 10.2561L3.31906 21.5159C3.31906 24.2903 5.57878 26.561 8.33972 26.561C8.77298 26.561 9.18924 26.5012 9.59701 26.3903V26.5098C9.59701 29.2842 11.8567 31.5549 14.6177 31.5549C17.3786 31.5549 19.6383 29.2842 19.6383 26.5098V5.26217C19.6383 2.48778 17.3786 0.217041 14.6177 0.217041Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.6458 5.2195C50.2125 5.2195 49.7963 5.27926 49.3885 5.39023V5.27072C49.3885 2.49632 47.1288 0.225586 44.3678 0.225586C41.6069 0.225586 39.3472 2.49632 39.3472 5.27072V26.5269C39.3472 29.3013 41.6069 31.572 44.3678 31.572C47.1288 31.572 49.3885 29.3013 49.3885 26.5269V26.4074C49.7878 26.5098 50.2125 26.5781 50.6458 26.5781C53.4067 26.5781 55.6664 24.3074 55.6664 21.533V10.2732C55.6664 7.49877 53.4067 5.22804 50.6458 5.22804V5.2195Z",
    fill: "#0074FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M9.58383 5.69897L9.58383 26.1597",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 46",
    d: "M48.9816 5.69897V26.1597",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_7111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.2831,
    height: 31.3549,
    fill: "white",
    transform: "translate(0.413696 0.217041)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/헬스.2e4550ef43cb63edd650b9d1b6ac965f.svg";
export { ForwardRef as ReactComponent };